import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import "./Carousel.css";
import { getData } from "app/data";
import { Link } from "react-router-dom";
import VimeoComponent from "components/Vimeo/VimeoComponent";

export default function CarouselSection(props) {
  const carouselData = getData(props.id);

  const [indexCar, setIndexCar] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleSelect = selectedIndex => {
    setIndexCar(selectedIndex);
    if (isPlaying) {
      setIsPlaying(false);
    }
  };

  return (
    <Carousel
      // className="robo-pages"
      activeIndex={indexCar}
      onSelect={handleSelect}
      variant="dark"
      interval={3000}
    >
      {carouselData
        ? carouselData.map(item => (
            <Carousel.Item key={item.id}>
              <div className="header">
                {item.title ? <h2>{item.title}</h2> : null}
                {item.text ? <p>{item.text}</p> : null}
              </div>
              {item.imgUrl ? (
                <div className="image-wrapper">
                  <img
                    className="d-block w-100 slide-image"
                    src={item.imgUrl}
                    alt="First slide"
                  />
                </div>
              ) : item.videoUrl ? (
                <div id="video-wrapper">
                  <VimeoComponent
                    videoUrl={item.videoUrl}
                    isPlaying={isPlaying}
                    setIsPlaying={setIsPlaying}
                  />
                </div>
              ) : null}
              <div className="button-wrapper d-flex">
                {item.buttonText ? (
                  <Link to={item.buttonLink} className="primary">
                    {item.buttonText}
                  </Link>
                ) : item.buttonImage ? (
                  <a href={item.buttonLink} target="_blank">
                    <img src={item.buttonImage} className="button-img" />
                  </a>
                ) : null}
                {item.button2Text ? (
                  <a href={item.button2Link} className="primary">
                    {item.button2Text}
                  </a>
                ) : item.button2Image ? (
                  <a href={item.button2Link} target="_blank">
                    <img src={item.button2Image} className="button-img" />
                  </a>
                ) : null}
              </div>
            </Carousel.Item>
          ))
        : null}
    </Carousel>
  );
}
